import { call, put, select } from 'redux-saga/effects';
import icvcActions from 'redux/actions/icvcActions';
import getPolicies from 'api/icvc';
import { maxIcvcCallAttemptsSelector } from 'redux/selectors/config';
import applicationSpinnerActions from 'redux/actions/applicationSpinnerActions';

const { startLoad, stopLoad } = applicationSpinnerActions;
const { getPoliciesError, getPoliciesSuccess } = icvcActions;

export function* retryIcvcCall(body, maxIcvcCallAttempts) {
  let attempt = 0;
  let response = { message: 'Error on ICVC call' };
  while (
    attempt < maxIcvcCallAttempts &&
    (!response || !response?.status || response?.status >= 500)
  ) {
    try {
      response = yield call(getPolicies, { body });
      if (!response?.status || response?.status >= 500) {
        attempt++;
      }
    } catch (e) {
      response = e;
      attempt++;
    }
  }
  return response;
}

export function* getPoliciesSaga({ payload: body }) {
  try {
    yield put(startLoad({ label: 'icvc_retry_loader-label' }));
    const maxIcvcCallAttempts = yield select(maxIcvcCallAttemptsSelector);
    const response = yield call(retryIcvcCall, body, maxIcvcCallAttempts);
    if (response.status === 200) {
      yield put(getPoliciesSuccess(response.result));
      return;
    }
    yield put(getPoliciesError(response));
  } catch (error) {
    yield put(getPoliciesError(error));
  } finally {
    yield put(stopLoad());
  }
}
